import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'ag-grid-community/styles/ag-grid.css'; // core AG Grid CSS
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import '../src/css/App.css';
import '../src/css/ag-grid-seven.css';
import '../src/css/ag-grid-seven-balham.css';
import { CustomThemeProvider } from './components/contexts/ThemeContext';
// import {
//     ModuleRegistry,
//     AllCommunityModule, // or AllEnterpriseModule
// } from 'ag-grid-community';

// // Register the module
// ModuleRegistry.registerModules([
//     AllCommunityModule, // or AllEnterpriseModule
// ]);

ReactDOM.render(
  <React.StrictMode>
    
      <BrowserRouter>
        <CustomThemeProvider>
          <App />
        </CustomThemeProvider>
      </BrowserRouter>
    
  </React.StrictMode >,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
